import { GoogleOAuthProvider } from "@react-oauth/google";
import { createConsumer } from "@rails/actioncable";
import { ActionCableProvider } from "react-actioncable-provider";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";

import "./common.css";

import CustomToast from "./components/common/CustomToast";
import { router } from "./Routing/Routes";
import { websocketApi } from "./variable";

function App() {
  const { authParams, user, googleClientId } = useSelector(state => ({
    user: state.auth.user,
    authParams: state.auth.authParams,
    googleClientId: state.auth.googleAuth?.clientId,
  }));

  const uid = authParams?.uid || user?.uid;

  // Create the cable once per uid. Re-creating it on every render causes
  // zombie WebSocket connections and "Cannot read properties of undefined
  // (reading 'received')" errors inside ActionCable's notify loop.
  const cable = useMemo(() => {
    return createConsumer(`${websocketApi}?uid=${encodeURIComponent(uid)}`);
  }, [uid]);

  // Disconnect the old cable when a new one is created (uid changed or unmount).
  useEffect(() => {
    window.cable = cable;
    return () => {
      cable.disconnect();
    };
  }, [cable]);

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <ActionCableProvider cable={cable}>
        <ToastProvider
          components={{ Toast: CustomToast }}
          placement="bottom-left"
        >
          <RouterProvider router={router} />
        </ToastProvider>
      </ActionCableProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
